<template>
  <div class="remote-control-container">
    <div>
      <input type="text" placeholder="connect local service">
      <button>connect</button>
    </div>
    <div class="agent-cards">
      <el-tabs>
        <el-tab-pane label="Agents">
          <div>
            <AgentCard v-for="(a, ai) in agents" :key="ai" :agent="a" />
          </div>
          <el-tabs>
            <el-tab-pane label="Listeners">
              <!-- table for agent.listeners -->
              <el-table :data="services">
                <el-table-column type="index" label="#"></el-table-column>
                <el-table-column prop="port" label="Listen Port"/>
                <el-table-column prop="secret" label="Secret"/>
                <el-table-column prop="type" label="Service Type"/>
                <el-table-column prop="logName" label="Log Name"/>
                <el-table-column prop="accepts" label="Accepts"/>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="Connections"></el-tab-pane>
            <el-tab-pane label="Control"></el-tab-pane>
          </el-tabs>
        </el-tab-pane>
        <el-tab-pane label="Services">
          <el-table>
            <el-table-column></el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import AgentCard from './AgentCard.vue'

export default {
  components: {
    AgentCard
  },
  data() {
    return {
      agents: [{
        network: 'txy',
        domain: 'cmsoffice_sgz',
        server: '5kbps.com:2040',
      },{
        network: 'funlp',
        domain: 'devcloud_sgz',
        server: 'funlp.cmschina.com.cn:9093'
      }],

      services: [{
        port: 1900,
        secret: '',
        type: 'portproxy',
        logName: 'pp1',
        accepts: 12
      }, {
        port: 1901,
        secret: 'xst',
        type: 'portproxy',
        logName: 'pp2',
        accepts: 9
      }]
    }
  }
}
</script>

<style lang="less" scoped>
.agent-cards {
  margin: 10px 0;
  padding: 10px;
  background-color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/RemoteControl/RemoteControl.vue